import {Base} from "@/api/Base"

export class SettingsGet extends Base {
    path = "settings/get"
}